module.exports = __webpack_public_path__ + "static/media/ag_logo.142e0f38.png";